import React, { useRef, useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import Skeleton from "react-loading-skeleton";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { FaHeart, FaRegComment, FaRegHeart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleProfileNavigate } from "../../utils/handleProfileNavigate";

const PinboardComment = ({
    comments, replies, replyLoading, setComments, id, getPinboardReplies,
    loading, deleteComment, handleEditPinboardComment, handleLikefn, handleReplyLikefn, reportComment, setOpenReplyPopup, deleteReply, editCommentReply }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const replyPopupRef = useRef(null);
    const { User_profile } = useSelector((state) => state.AccountProfile);
    const [openPopoverId, setOpenPopoverId] = useState(null);
    const [replyText, setReplyText] = useState("");
    const [showReplies, setShowReplies] = useState(false);
    const [repliesData, setRepliesData] = useState([]);
    const [commentId, setCommentId] = useState(null);


    const handleNavigate = handleProfileNavigate(navigate, User_profile?.id);

    const handlePopoverToggle = (id) => {
        setOpenPopoverId((prevId) => (prevId === id ? null : id));
    };

    const handleReplyPopupToggle = (comment) => {
        setOpenReplyPopup((prevComment) => (prevComment && prevComment.id === comment.id ? null : comment));
        setOpenPopoverId(null); // Close popover when reply popup is opened
    };

    const handleClickOutside = (event) => {
        if (replyPopupRef.current && !replyPopupRef.current.contains(event.target)) {
            setOpenReplyPopup(null);
        }
    };



    const handleShowReplies = (commentId) => {
        setShowReplies((prevId) => (prevId === commentId ? null : commentId));
        if (showReplies !== commentId) {
            getPinboardReplies(commentId);
        }
    };

    const handleEditComment = (comment) => {
        handleEditPinboardComment(comment.id, comment);
        setOpenPopoverId(null); // Close popover when reply popup is opened
    };

    const handleEditCommentReply = (reply, commentId) => {
        editCommentReply(reply, commentId)
        setOpenPopoverId(null); // Close popover when reply popup is opened
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    function timeAgo(inputTime) {
        const units = [
            { name: 'year', seconds: 31536000 },
            { name: 'month', seconds: 2592000 },
            { name: 'week', seconds: 604800 },
            { name: 'day', seconds: 86400 },
            { name: 'hour', seconds: 3600 },
            { name: 'minute', seconds: 60 },
        ];

        const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

        const inputDate = new Date(inputTime);
        const currentDate = new Date();

        const diffInSeconds = Math.floor((currentDate - inputDate) / 1000);

        // ✅ Handle "just now" case
        if (diffInSeconds < 60) {
            return 'just now';
        }

        for (const unit of units) {
            const amount = Math.floor(diffInSeconds / unit.seconds);
            if (amount >= 1) {
                return rtf.format(-amount, unit.name);
            }
        }

        return 'just now'; // fallback
    }



    return (
        <div className="pt-1">
            {loading &&
                [1, 2, 3, 4, 6, 6, 7, 8, 9, 9, 4, 4, 4].map(() => (
                    <div className="grid grid-cols-12 p-2 py-1 " >
                        <div className="col-span-2 flex justify-start items-center">
                            <Skeleton
                                height={30}
                                width={30}
                                circle={true}
                            />
                        </div>
                        <div className="col-span-4 -ml-3">
                            <Skeleton
                                height={15}
                                width={150}
                            />
                            <Skeleton
                                height={15}
                                width={100}
                            />
                        </div>
                        <div className="col-span-6 flex justify-end  gap-2 items-center">
                            <Skeleton
                                height={15}
                                width={15}
                            />
                            <Skeleton
                                height={15}
                                width={15}
                            />
                        </div>

                        <div className="col-span-12 flex justify-start  gap-2 items-center">
                            {/* <Skeleton
                                height={150}
                                width={300}
                            /> */}
                        </div>
                    </div>
                ))
            }
            {!loading && comments?.map((comment) => (
                <div key={comment.id} className="py-2 px-2 border-b border-gray-400 dark:border-gray-800">
                    <div className="flex items-start">
                        <div className="w-7 h-6">
                            <img
                                onClick={() => handleNavigate(comment.created_by.id)}
                                alt="User"
                                src={comment.created_by.avatar_url}
                                className="w-6 h-6 object-cover rounded-full cursor-pointer"
                            />
                        </div>
                        <div className="flex flex-col ml-2 w-full">
                            <div className="flex items-center justify-between gap-x-1">
                                <div className="flex items-center gap-x-1">
                                    <p className="text-[11px] font-bold dark:text-gray-200 cursor-pointer" onClick={() => handleNavigate(comment.created_by.id)}>
                                        {comment.created_by.first_name} {comment.created_by.last_name}
                                    </p>
                                    <div className="relative">
                                        <HiOutlineDotsVertical
                                            onClick={() => handlePopoverToggle(comment.id)}
                                            className="text-[12px] cursor-pointer text-gray-600 dark:text-gray-300 mr-[-5px]"
                                        />
                                        {openPopoverId === comment.id && (
                                            <div className="absolute -right-12 -top-1 w-10 bg-white dark:bg-[#2d2b2b] border border-gray-800 overflow-hidden rounded shadow-lg">
                                                {User_profile.id === comment.created_by.id && <div
                                                    onClick={() => handleEditComment(comment)}
                                                    className="px-2 py-[1px] text-[8px] text-gray-700 dark:text-gray-200 dark:hover:bg-gray-500 hover:bg-gray-300 hover:text-black cursor-pointer"
                                                >
                                                    Edit
                                                </div>}
                                                {User_profile.id === comment.created_by.id && <div
                                                    onClick={() => deleteComment(comment.id)}
                                                    className="px-2 py-[1px] text-[8px] text-gray-700 dark:text-gray-200 dark:hover:bg-gray-500 hover:bg-gray-300 hover:text-black cursor-pointer"
                                                >
                                                    Delete
                                                </div>}
                                                {/* <div
                                                    className="px-2 py-[1px] text-[8px] text-gray-700 dark:text-gray-200 dark:hover:bg-gray-500 hover:bg-gray-300 hover:text-black cursor-pointer"
                                                >
                                                    Mute
                                                </div> */}
                                                {!User_profile.id === comment.created_by.id && <div
                                                    onClick={() => reportComment(comment)}
                                                    className="px-2 py-[1px] text-[8px] text-gray-700 dark:text-gray-200 dark:hover:bg-gray-500 hover:bg-gray-300 hover:text-black cursor-pointer"
                                                >
                                                    Report
                                                </div>}
                                                <div
                                                    onClick={() => handleReplyPopupToggle(comment)}
                                                    className="px-2 py-[1px] text-[8px] text-gray-700 dark:text-gray-200 dark:hover:bg-gray-500 hover:bg-gray-300 hover:text-black cursor-pointer"
                                                >
                                                    Reply
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex items-center gap-x-4">
                                    <div className="flex flex-col items-center">
                                        {comment?.is_liked ? (
                                            <FaHeart className="text-[10px] text-red-600 cursor-pointer" onClick={() => handleLikefn(comment.id)} />
                                        ) : (
                                            <FaRegHeart className="text-[10px] text-gray-600 cursor-pointer" onClick={() => handleLikefn(comment.id)} />
                                        )}
                                        <p className="text-[8px] text-gray-500">{comment?.likes_count}</p>
                                    </div>
                                    <div className="flex flex-col items-center">
                                        <FaRegComment
                                            onClick={() => setOpenReplyPopup(comment)}
                                            className="text-[10px] text-gray-600 cursor-pointer"
                                        />
                                        <p className="text-[8px] text-gray-500">{comment.reply_count}</p>
                                    </div>
                                </div>
                            </div>
                            <p className="text-[8px] text-gray-500 mt-[-5px]">
                                {timeAgo(comment?.created_at)}
                            </p>
                            <p className="text-[10px] mt-[2px] dark:text-gray-200">
                                {comment.post_comment_box}
                            </p>
                            {comment.reply_count > 0 && <p onClick={() => handleShowReplies(comment.id)} className="text-[10px] cursor-pointer text-start  text-blue-600">
                                {showReplies === comment.id ? "close replies" : " See replies"}   </p>}
                            {showReplies === comment.id && <div className="h-[0.5px] bg-gray-400 dark:bg-gray-800 w-[86%] my-1" />}
                            {replyLoading && showReplies === comment.id ? (
                                [1, 2, 3, 4, 5, 7, 8, 9].map((item) => (
                                    <div className="grid grid-cols-12  py-1" key={item} >
                                        <div className="col-span-2 flex justify-start items-center">
                                            <Skeleton
                                                height={30}
                                                width={30}
                                                circle={true}
                                            />
                                        </div>
                                        <div className="col-span-4 -ml-3">
                                            <Skeleton
                                                height={15}
                                                width={150}
                                            />
                                            <Skeleton
                                                height={15}
                                                width={100}
                                            />
                                        </div>
                                    </div>
                                ))
                            ) : null}

                            {!replyLoading && showReplies === comment.id && replies?.map((reply) => (
                                <div key={reply.id} className="flex mt-1">
                                    <div className="w-7 h-6">
                                        <img
                                            onClick={() => handleNavigate(reply.created_by.id)}
                                            alt="User"
                                            className="w-6 h-6 object-cover rounded-full cursor-pointer"
                                            src={reply?.created_by?.avatar_url}
                                        />
                                    </div>
                                    <div className="flex flex-col ml-2 w-full">
                                        <div className="flex items-center justify-between gap-x-1">
                                            <div className="flex items-center gap-x-1">
                                                <p className="text-[11px] font-bold dark:text-gray-200 cursor-pointer" onClick={() => handleNavigate(reply.created_by.id)}>
                                                    {reply?.created_by?.first_name} {reply?.created_by?.last_name}
                                                </p>
                                                <div className="relative">
                                                    {User_profile.id === reply.created_by.id && <HiOutlineDotsVertical
                                                        onClick={() => handlePopoverToggle(reply.id)}
                                                        className="text-[12px] cursor-pointer text-gray-600 dark:text-gray-300 mr-[-5px]"
                                                    />}
                                                    {openPopoverId === reply.id && (
                                                        User_profile.id === reply.created_by.id ? <div ref={replyPopupRef} className="absolute -right-12 -top-1 w-10 bg-white dark:bg-[#2d2b2b] border border-gray-800 overflow-hidden rounded shadow-lg">
                                                            <div
                                                                onClick={() => handleEditCommentReply(reply, reply.id)}
                                                                className="px-2 py-[1px] text-[8px] text-gray-700 dark:text-gray-200 dark:hover:bg-gray-500 hover:bg-gray-300 hover:text-black cursor-pointer"
                                                            >
                                                                Edit
                                                            </div>
                                                            <div
                                                                onClick={() => deleteReply(reply.id, comment.id)}
                                                                className="px-2 py-[1px] text-[8px] text-gray-700 dark:text-gray-200 dark:hover:bg-gray-500 hover:bg-gray-300 hover:text-black cursor-pointer"
                                                            >
                                                                Delete
                                                            </div>
                                                        </div> : null
                                                    )}
                                                </div>
                                            </div>
                                            <div className="flex flex-col items-center">
                                                {reply?.is_liked ? (
                                                    <FaHeart className="text-[10px] text-red-600 cursor-pointer" onClick={() => handleReplyLikefn(reply.id)} />
                                                ) : (
                                                    <FaRegHeart className="text-[10px] text-gray-600 cursor-pointer" onClick={() => handleReplyLikefn(reply.id)} />
                                                )}
                                                <p className="text-[8px] text-gray-500">{reply?.likes_count}</p>
                                            </div>
                                        </div>
                                        <p className="text-[8px] text-gray-500 mt-[-3px]">
                                            {timeAgo(reply?.created_at)}
                                        </p>
                                        <p className="text-[10px] mt-[2px] dark:text-gray-200">
                                            {reply?.post_comment_box}
                                        </p>
                                    </div>
                                </div>
                            ))}
                            {showReplies === comment.id && replies?.length == 0 && (
                                <div className="flex justify-center items-center h-[25vh]">
                                    <p className="text-gray-500 dark:text-gray-300 text-[12px]">No replies yet.</p>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            ))}
            {comments?.length === 0 && !loading && (
                <div className="flex justify-center items-center h-[30vh]">
                    <p className="text-gray-500 dark:text-gray-300 text-[12px]">No comments yet.</p>
                </div>
            )
            }
            {/* {openReplyPopup && (
                <div className="absolute inset-0 flex items-center justify-center h-full bg-black bg-opacity-50 z-20">
                    <div ref={replyPopupRef} className="bg-white dark:bg-[#2b2b2b] p-4 m-2 rounded shadow-lg w-80">
                        <div className="flex justify-between items-center mb-2">
                            <div className="flex items-start">
                                <img
                                    alt="User"
                                    className="w-6 h-6 object-cover rounded-full"
                                    src={openReplyPopup.created_by.avatar}
                                />
                                <div className="ml-2">
                                    <p className="text-[11px] font-bold dark:text-gray-300">{openReplyPopup.created_by.first_name} {
                                        openReplyPopup.created_by.last_name}</p>
                                    <p className="text-[8px] text-gray-500">{timeAgo(openReplyPopup.created_at)}</p>
                                </div>
                            </div>
                            <IoMdClose
                                onClick={() => setOpenReplyPopup(null)}
                                className="text-[20px] text-gray-900 dark:text-gray-200 hover:text-red-700 cursor-pointer"
                            />
                        </div>
                        <p className="text-[10px] mb-2 dark:text-gray-400">{openReplyPopup.body}</p>
                        <textarea
                            rows={2}
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            placeholder="Write your reply..."
                            className="w-full p-2 border border-gray-400 dark:border-gray-800 dark:bg-[#292828] dark:text-gray-200 rounded resize-none focus:outline-none text-[10px]"
                        />
                        <button
                            onClick={() => handleCreateReply(openReplyPopup.id , replyText)}
                            className="mt-2 bg-gray-900 hover:bg-black text-[12px] text-white px-4 py-1 rounded transition-colors duration-500">
                            {editReply ? "Update Reply" : "Reply"}
                        </button>
                    </div>
                </div>
            )} */}

        </div>
    );
};

export default PinboardComment;